import { Box, Container, Typography, Divider, useTheme } from "@mui/material";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import BlockRenderer from "../../BlockRenderer";
import "./bold.css";

export default function BoldPage({ page, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;
  const muiTheme = useTheme();

  return (
    <Box className="website-bold" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "#0f0f0f" }}>
      <SeoHead title={page.seo_title || page.title} description={page.seo_description} ogImage={page.seo_og_image} schoolName={school?.name} />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="bold" />

      <BlockRenderer blocks={page.page_blocks} />

      {page.featured_image && !page.page_blocks?.length && (
        <Box component="img" src={page.featured_image} alt={page.title}
          sx={{ width: "100%", maxHeight: 420, objectFit: "cover", display: "block" }}
        />
      )}

      {(page.content?.trim() || !page.page_blocks?.length) && (
        <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
          {!page.page_blocks?.length && (
            <Typography variant="h3" fontWeight={900} sx={{ color: "white", mb: 1 }}>{page.title}</Typography>
          )}
          {!page.page_blocks?.length && (
            <Divider sx={{ borderColor: muiTheme.palette.primary.main, borderWidth: 3, mb: 4, width: 60 }} />
          )}
          {page.content?.trim() && (
            <Box
              className="prose-content"
              sx={{ bgcolor: "white", borderRadius: 3, p: 4 }}
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          )}
        </Container>
      )}

      <WebsiteFooter settings={activeSettings} school={school} variant="bold" />
    </Box>
  );
}
